import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-495badb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-x4 text-center" }
const _hoisted_2 = { class: "delivery-option" }
const _hoisted_3 = { class: "ml-30" }

import {
    PickUpCheckOutDeliverable,
} from '@/storecontext/shared/api/server-apis';
import CheckoutPickUpOption from '@/storecontext/checkout/ui/CheckoutPickUpOption.vue';
import CheckoutDeliverableItems from '@/storecontext/checkout/ui/items/CheckoutDeliverableItems.vue';
import CheckoutDeliverableGoToNext from '@/storecontext/checkout/ui/CheckoutDeliverableGoToNext.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { ref } from 'vue';
import CheckoutPickUpDeliverableSkeleton
    from '@/storecontext/checkout/ui/deliverables/CheckoutPickUpDeliverableSkeleton.vue';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickUpDeliverable',
  props: {
    deliverable: null,
    index: null
  },
  setup(__props: any) {


const labels = useBlockLabels();
const { getPickUpErrorMessageId } = useCheckout();
const hubsLoaded = ref<boolean>(false);
const onHubsLoaded = (): void => {
    hubsLoaded.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$dictionary.pluralize(__props.deliverable.itemIds.length, _unref(labels).pickUpDescription, _unref(labels).pickUpDescriptionPlural)), 1),
    (__props.deliverable.id)
      ? (_openBlock(), _createBlock(CheckoutDeliverableItems, {
          key: 0,
          deliverable: __props.deliverable
        }, null, 8, ["deliverable"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(CheckoutPickUpDeliverableSkeleton, null, null, 512), [
      [_vShow, !hubsLoaded.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(labels).pickUpTitle), 1),
      _createVNode(CheckoutPickUpOption, {
        class: "mt-8",
        deliverable: __props.deliverable,
        onHubsLoaded: onHubsLoaded
      }, null, 8, ["deliverable"])
    ], 512), [
      [_vShow, hubsLoaded.value]
    ]),
    _createVNode(WebApiMessage, {
      id: _unref(getPickUpErrorMessageId)(__props.deliverable.id),
      "clear-timing": 100000000,
      class: "ml-60 mt-10"
    }, null, 8, ["id"]),
    _createVNode(CheckoutDeliverableGoToNext, {
      index: __props.index,
      deliverable: __props.deliverable
    }, null, 8, ["index", "deliverable"])
  ]))
}
}

})